import { initializeGrid } from "./base"

if (document.querySelectorAll(".charging_log_entries-index").length) {
  initializeGrid({
    gridName: "charging_log_entries",
    sizeColumnsToFit: true, autoSizeStrategy: {
      defaultMinWidth: 100,
      type: "fitGridWidth"
    }})
}
